export const WORD_PACKS = {
  everyday: [
    'parapluie', 'bougie', 'miroir', 'coussin', 'tiroir', 'lampe', 'brosse',
    'savon', 'rideau', 'échelle', 'valise', 'horloge', 'ciseaux', 'marteau',
    'stylo', 'cahier', 'tapis', 'torchon', 'fourchette', 'casserole',
  ],
  sports: [
    'kimono', 'tatami', 'arbitre', 'podium', 'médaille', 'ceinture', 'kata',
    'kumité', 'dojo', 'sensei', 'protège-dents', 'bandage', 'trophée',
    'chronomètre', 'couloir', 'trampoline', 'maillot', 'short', 'casque',
  ],
  food: [
    'sushi', 'croissant', 'mozzarella', 'avocat', 'tiramisu', 'fondue',
    'ratatouille', 'baguette', 'camembert', 'crêpe', 'macarons', 'ravioli',
    'guacamole', 'hummus', 'brioche', 'calzone', 'tabbouleh', 'churros',
  ],
  animals: [
    'flamant', 'crocodile', 'pieuvre', 'koala', 'narval', 'taupe', 'ocelot',
    'wombat', 'axolotl', 'capybara', 'pangolin', 'okapi', 'tapir', 'glouton',
    'marsouin', 'ornithorynque', 'binturong', 'caracal', 'serval', 'tatou',
  ],
  places: [
    'Maroc', 'Tokyo', 'Sahara', 'Venise', 'Islande', 'Amazonie', 'Tibet',
    'Mexique', 'Norvège', 'Maldives', 'Patagonie', 'Jordanie', 'Laos',
    'Louisiane', 'Zanzibar', 'Laponie', 'Birmanie', 'Bhoutan', 'Éthiopie',
  ],
};

export const PACK_LABELS = {
  everyday: 'Objets du quotidien',
  sports: 'Sports & Arts martiaux',
  food: 'Nourriture & Boissons',
  animals: 'Animaux',
  places: 'Pays & Lieux',
};
